/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TenantDomainBindingDto
 */
export interface TenantDomainBindingDto {
    /**
     * 
     * @type {string}
     * @memberof TenantDomainBindingDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantDomainBindingDto
     */
    customerId?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantDomainBindingDto
     */
    domainMappingId?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantDomainBindingDto
     */
    tenantId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TenantDomainBindingDto
     */
    primary?: boolean;
}

/**
 * Check if a given object implements the TenantDomainBindingDto interface.
 */
export function instanceOfTenantDomainBindingDto(value: object): value is TenantDomainBindingDto {
    return true;
}

export function TenantDomainBindingDtoFromJSON(json: any): TenantDomainBindingDto {
    return TenantDomainBindingDtoFromJSONTyped(json, false);
}

export function TenantDomainBindingDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TenantDomainBindingDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'customerId': json['customerId'] == null ? undefined : json['customerId'],
        'domainMappingId': json['domainMappingId'] == null ? undefined : json['domainMappingId'],
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'primary': json['primary'] == null ? undefined : json['primary'],
    };
}

export function TenantDomainBindingDtoToJSON(json: any): TenantDomainBindingDto {
    return TenantDomainBindingDtoToJSONTyped(json, false);
}

export function TenantDomainBindingDtoToJSONTyped(value?: TenantDomainBindingDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'customerId': value['customerId'],
        'domainMappingId': value['domainMappingId'],
        'tenantId': value['tenantId'],
        'primary': value['primary'],
    };
}

